export const faceSwapeCameraOptions = {
    photography: {
      cameraType: {
        label: 'Camera Type',
        options: {
          fullFrameDslr: 'Full-frame DSLR',
          apsC: 'APS-C Camera',
          mirrorless: 'Mirrorless Camera',
          mediumFormat: 'Medium Format Camera',
          pointAndShoot: 'Point-and-shoot Camera',
          phone: 'Phone Camera'
        }
      },
      lensType: {
        label: 'Lens Type',
        options: {
          standard: 'Standard lens (50mm f/1.8)',
          wideAngle: 'Wide-angle lens (35mm, 24mm)',
          mediumTelephoto: 'Medium telephoto lens (85mm, 105mm)',
          telephoto: 'Telephoto lens (200mm, 300mm)',
          macro: 'Macro lens',
          fisheye: 'Fisheye lens',
          zoom: 'Zoom lens (24-70mm, 70-200mm)',
          prime: 'Prime lens (35mm, 50mm, 85mm)',
          largeAperture: 'Large aperture lens (f/1.2, f/1.4)'
        }
      },
      focalLength: {
        label: 'Focal Length',
        options: {
          ultraWide: 'Ultra-wide angle (10mm-24mm)',
          wide: 'Wide angle (35mm, 50mm)',
          standard: 'Standard (85mm, 105mm)',
          telephoto: 'Telephoto (200mm, 300mm)',
          superTelephoto: 'Super-telephoto (400mm, 600mm)'
        }
      },
      aperture: {
        label: 'Aperture',
        options: {
          large: 'Large aperture (f/1.2, f/1.4)',
          medium: 'Medium aperture (f/2.8, f/3.5)',
          small: 'Small aperture (f/8, f/11)'
        }
      },
      shutterSpeed: {
        label: 'Shutter Speed',
        options: {
          fast: 'Fast shutter (1/1000s, 1/500s)',
          medium: 'Medium shutter (1/250s, 1/125s)',
          slow: 'Slow shutter (1/60s, 1/30s)'
        }
      },
      iso: {
        label: 'ISO',
        options: {
          low: 'Low ISO (100-400)',
          medium: 'Medium ISO (800-1600)',
          high: 'High ISO (3200-6400)'
        }
      },
      whiteBalance: {
        label: 'White Balance',
        options: {
          auto: 'Auto',
          daylight: 'Daylight',
          cloudy: 'Cloudy',
          tungsten: 'Tungsten',
          fluorescent: 'Fluorescent',
          custom: 'Custom'
        }
      },
      focusMode: {
        label: 'Focus Mode',
        options: {
          singlePoint: 'Single-point AF',
          zone: 'Zone AF',
          auto: 'Auto AF',
          faceDetection: 'Face detection AF',
          tracking: 'Tracking AF',
          manual: 'Manual focus'
        }
      },
      exposureMode: {
        label: 'Exposure Mode',
        options: {
          auto: 'Auto exposure',
          shutterPriority: 'Shutter priority',
          aperturePriority: 'Aperture priority',
          manual: 'Manual exposure',
          compensation: 'Exposure compensation'
        }
      },
      shootingMode: {
        label: 'Shooting Mode',
        options: {
          single: 'Single shot',
          burst: 'Burst mode',
          timeLapse: 'Time-lapse',
          slowMotion: 'Super slow-motion'
        }
      },
      shootingAngle: {
        label: 'Shooting Angle',
        options: {
          high: 'High angle (looking down)',
          low: 'Low angle (looking up)',
          front: 'Front view',
          side: 'Side view',
          fortyFive: '45-degree angle'
        }
      },
      pose: {
        label: 'Pose',
        options: {
          power: 'Power Pose',
          walking: 'Walking Pose',
          sCurve: 'S-curve Pose',
          sitting: 'Sitting Pose',
          leaning: 'Leaning Pose',
          headshot: 'Headshot Pose',
          handOnHip: 'Hand-on-Hip Pose',
          candidLaugh: 'Candid Laugh Pose',
          highFashion: 'High Fashion Pose'
        }
      }
    }
  };
